// hooks/usePushNotifications.js
// Registra el SW, pide permiso, crea la suscripción y la envía al backend.

import { useEffect, useState } from 'react';

const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';
const PUBLIC_KEY_ENDPOINT = `${apiUrl}/api/push/public-key`;

// Convierte la clave pública VAPID (Base64 URL-safe) a Uint8Array
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

/**
 * Hook de inicialización de notificaciones push.
 *  - Devuelve: 'idle' | 'unsupported' | 'denied' | 'no-token' | 'subscribed' | 'error'
 *  - Ejecutar DESPUÉS de que exista el JWT (usuario logeado).
 */
export default function usePushNotifications() {
  const [status, setStatus] = useState('idle');

  useEffect(() => {
    (async () => {
      // 0. Compatibilidad
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.warn('[push] El navegador no soporta SW o Push API');
        setStatus('unsupported');
        return;
      }

      // 1. Registrar Service Worker (si no existe)
      const swReg = await navigator.serviceWorker.register('/sw.js');

      // 2. Solicitar permiso
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.info('[push] Permiso denegado');
        setStatus('denied');
        return;
      }

      // 3. Necesitamos el token JWT para /subscribe
      //const token = localStorage.getItem('token');
     // if (!token) {
      //  console.warn('[push] Sin JWT: se pospone envío de suscripción');
       // setStatus('no-token');
        //return;
      

      try {
        // 4. Obtener clave pública VAPID
        const { publicKey } = await (await fetch(PUBLIC_KEY_ENDPOINT)).json();
        if (!publicKey) throw new Error('Clave VAPID no recibida');

        // 5. Obtener o crear la suscripción
        let subscription = await swReg.pushManager.getSubscription();
        if (!subscription) {
          subscription = await swReg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicKey),
          });
        }

        // 6. Enviar al backend
        const res = await fetch(`${apiUrl}/api/push/subscribe`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          // Authorization: token || undefined,   // solo el JWT, sin “Bearer ”
          },
          body: JSON.stringify(subscription.toJSON()),
        });

        if (!res.ok) throw new Error(`Backend respondió ${res.status}`);
        console.log('[push] Suscripción guardada en backend');
        setStatus('subscribed');
      } catch (err) {
        console.error('[push] Error:', err);
        setStatus('error');
      }
    })();
  }, []); // se ejecuta una sola vez

  return status;
}
